module.exports = __webpack_public_path__ + "img/showcase-searches-en-ca.f336887c.jpg";